const Seo = ({
  title, description, canonicalUrl, ogType = 'website', ogImage, twitterCard = 'summary_large_image', twitterImage, keyWords, ogDescription
}) => {
  return (
    <>
    {/* Primary SEO tags for search engines */}
    {/* The <title> tag should always be present */}
    <title>{title}</title>
    {/* Description meta tag for search snippets */}
    <meta name="description" content={description} />
    {/* meta author */}
    <meta name="author" content="imoxkitchen" />
      {/* meta robot */}
    <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
    {/* Canonical URL to prevent duplicate content issues */}
    {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    {/* meta keyword*/}
    <meta name="keywords" content={keyWords} />
    {/* Open Graph tags for rich social media previews (e.g., Facebook, LinkedIn, etc.) */}
    {/* These tags control how your content appears when shared on social platforms */}
    <meta property="og:title" content={title} />
    <meta property="og:description" content={ogDescription} />
    <meta property="og:url" content={canonicalUrl} />
    <meta property="og:type" content={ogType} />
    {/* Only render og:image if a value is provided */}
    {ogImage && <meta property="og:image" content={ogImage} />}
    <meta property="og:site_name" content="Imox kitchen" />
    <meta property="article:publisher" content="https://www.facebook.com/kitchenequipmentcompany" />
    {/* Twitter Card tags for Twitter specific rich previews */}
    {/* These tags ensure your content looks good when tweeted */}
    <meta name="twitter:card" content={twitterCard} />
    <meta name="twitter:title" content= "Commercial Kitchen Equipment Store" /> 
    <meta name="twitter:description" content={ogDescription} />
    {/* Only render twitter:image if a value is provided */}
    {twitterImage && <meta name="twitter:image" content={twitterImage} />}
    {/* Additional meta tags can be added here if needed, e.g., author, keywords, robots, etc. */}
    {/* <meta name="author" content="Your Company Name" /> */}
    {/* <meta name="keywords" content="react app, web development, seo, example" /> */}
    {/* <meta name="robots" content="index, follow" /> */}
    </>
  )
}
export default Seo